import { Component, type ReactNode } from "react";
import { DeliveryErrorDetails } from "./delivery-control";
import { newDeliveryReference, reportDeliveryDiagnostic } from "@/lib/ads-manager-delivery-diagnostic";

export class DeliveryDialogBoundary extends Component<{
  children: ReactNode; brandId: string; accountId: string; requestedStatus: "ACTIVE" | "PAUSED";
}, { reference: string | null }> {
  state = { reference: null as string | null };
  static getDerivedStateFromError() { return { reference: newDeliveryReference() }; }
  componentDidCatch() {
    reportDeliveryDiagnostic({ reference: this.state.reference!, stage: "dialog", reason: "dialog_failed",
      brandId: this.props.brandId, accountId: this.props.accountId, requestedStatus: this.props.requestedStatus,
      dispatchState: "not_sent", durationMs: 0 });
  }
  render() {
    return this.state.reference ? <div role="alert">
      The confirmation couldn’t open. No change was sent. Refresh the page to try again.
      <DeliveryErrorDetails reference={this.state.reference} />
    </div> : this.props.children;
  }
}
